/** @format */

import { GTMListingSelectItem } from '@/ducks/googleTagManager/helpers/google-tag-manager';
import { ListingFilters } from '@/ducks/listing/types';
import { TRoom } from '@/ducks/room/declarations';
import { findLocalizedData } from '@/i18n/utils/find-localized-data';
import { getGtmRoomType } from '@/utils/helpers/getGtmRoomType';
import { utilityIsRoomAvailableFrom } from '@/utils/helpers/isRoomAvailableFrom';
import { utilityGetPrice } from '@/utils/helpers/utilityGetPrice';
import { IntlShape } from 'gatsby-plugin-intl';
import snakeCase from 'lodash/snakeCase';
import { RoomAvailability } from '../../@ducks/bookingNew/types';
import { TListType } from '../../@ducks/general/declarations';
import { TLocale } from '../gatsby/types';
import { utilityGTMBuildStringByListingActiveFilters } from './utilityGTMBuildStringByListingActiveFilters';

export const utilityGTMListingSelectItem = (
  room: TRoom,
  availability: RoomAvailability,
  intl: IntlShape,
  position: number,
  filters: ListingFilters,
  customTListType?: TListType,
) => {
  const orderBy = filters.orderBy === 'null' || !filters.orderBy ? 'availability_asc' : filters.orderBy;
  const activeCategoryFilter = utilityGTMBuildStringByListingActiveFilters(filters);

  const { getFormattedPrice, getDimension } = utilityGetPrice({
    availability: availability,
    room,
  });

  const isRoomAvailableFrom = utilityIsRoomAvailableFrom(availability);
  const isRoomNotAvailable = availability ? !availability?.availableFrom || availability?.negotiating : true;

  const itemListName = customTListType
    ? customTListType
    : activeCategoryFilter === ''
    ? 'search_result'
    : ('sorting_by_product_filters' as TListType);

  const localizedEntry = findLocalizedData(intl.locale as TLocale, room);
  const roomType = getGtmRoomType(room.flat.type);

  const data = {
    item_name: snakeCase(localizedEntry?.title ?? ''),
    item_id: room.code,
    price: getFormattedPrice(),
    item_brand: snakeCase(`${room.city.name}_${room.district.name}`),
    item_category: roomType,
    item_list_name: itemListName,
    position: position,
    rate_type: getDimension,
    availability: isRoomNotAvailable ? 'not_available' : isRoomAvailableFrom ? 'available_on_next_weeks' : 'available',
  };

  GTMListingSelectItem(data, orderBy, activeCategoryFilter);
};
